import React, { useEffect, useState } from "react";
import { useBottomSheet } from "../context/BottomSheetContext";
import { buscarComercios, getHistorialBusqueda, guardarEnHistorial, eliminarDelHistorial, getSugerenciasInteres, registrarComercioNoEncontrado, registrarTap } from "../api";
import { useNavigate } from "react-router-dom";
import StarRating from './StarRating';
import { debounce } from "lodash";

const BottomSheet = () => {
  const { isBottomSheetOpen, closeBottomSheet } = useBottomSheet();
  const navigate = useNavigate();
  const rawPerfil = localStorage.getItem("id_perfil");
  const id_perfil = rawPerfil === "null" || rawPerfil === null ? null : parseInt(rawPerfil, 10);
  const [mostrarSinResultados, setMostrarSinResultados] = useState(false);
  const [query, setQuery] = useState("");
  const [resultados, setResultados] = useState([]);
  const [historial, setHistorial] = useState([]);
  const [sugerencias, setSugerencias] = useState([]);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (isBottomSheetOpen) {
      setQuery("");
      getHistorial();
      getSugerencias();
    }
  }, [isBottomSheetOpen]);

  useEffect(() => {
    const buscar = async (term) => {
      if (term.length > 1) {
        const resultados = await buscarComercios(term);
        setResultados(resultados);
  
        if (resultados.length === 0) {
          await registrarComercioNoEncontrado(term);
          setMostrarSinResultados(true);
        } else {
          setMostrarSinResultados(false);
        }
      } else {
        setResultados([]);
        setMostrarSinResultados(false);
      }
    };
  
    const delayedBuscar = debounce(buscar, 600);
    delayedBuscar(query);
  
    return () => {
      delayedBuscar.cancel();
    };
  }, [query]);

  const getHistorial = async () => {
    if (id_perfil) {
      const data = await getHistorialBusqueda(id_perfil);
      setHistorial(data);
    } else {
      const temp = JSON.parse(localStorage.getItem("busquedas_temp") || "[]");
      const formato = temp.map((t, i) => ({
        id_busqueda: `local-${i}`,
        termino: t.termino,
        id_comercio: t.id_comercio || null,
        id_sucursal: t.id_sucursal || null,
        local: true,
      }));
      setHistorial(formato);

    }
  };

  const getSugerencias = async () => {
    const data = await getSugerenciasInteres(id_perfil);
    setSugerencias(data);
  };

  const handleSeleccion = async (termino, id_comercio = null) => {
    const temp = JSON.parse(localStorage.getItem("busquedas_temp") || "[]");

    const yaExiste = temp.find((t) => t.termino === termino);

    if (!yaExiste) {
      temp.unshift({
        termino,
        id_comercio: id_comercio || null,
        id_sucursal: id_comercio || null, // si querés almacenar ambos
      });
    
      if (temp.length > 10) temp.pop();
    
      localStorage.setItem("busquedas_temp", JSON.stringify(temp));
    }
  
    // Siempre mandamos al backend, aunque id_perfil sea null
    await guardarEnHistorial(id_perfil || null, termino, id_comercio || null);
  
    // Limpiar todo y redirigir si toca
    setQuery("");
    setResultados([]);
    closeBottomSheet();
    if (id_comercio) navigate(`/comercio/app/${id_comercio}`);
  };  

  const handleEliminar = async (id_busqueda) => {
    if (typeof id_busqueda === "string" && id_busqueda.startsWith("local-")) {
      const temp = JSON.parse(localStorage.getItem("busquedas_temp") || "[]");
      temp.splice(parseInt(id_busqueda.split("-")[1]), 1);
      localStorage.setItem("busquedas_temp", JSON.stringify(temp));
      getHistorial();
    } else {
      const id = parseInt(id_busqueda, 10);
      if (!isNaN(id)) {
        await eliminarDelHistorial(id);
        getHistorial();
      }
    }
  };
  

  return (
    <>
      <div className={`overlay ${isBottomSheetOpen ? "active" : ""}`} onClick={closeBottomSheet}></div>
      <div className={`bottom-sheet-wrapper ${isBottomSheetOpen ? "active" : ""}`}>
        <div className={`bottom-sheet ${isBottomSheetOpen ? "active" : ""}`}>
          <div className="dg">
            <div className="drag-handle" onClick={closeBottomSheet}>
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                <path fill="#d3d3d3" d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"/>
              </svg>
            </div>
          </div>
          <div className="bottom-sheet-content">
            <input type="text" placeholder="¿Qué tienes en mente?" className="search-input" value={query} onChange={(e) => setQuery(e.target.value)}/>
            {resultados.length > 0 ? (
              <div className="recent-searches">
                <ul id="recent-list">
                  {resultados.map((item) => (
                    <li key={item.id_comercio} onClick={() => handleSeleccion(item.nombre, item.id_sucursal)}>
                      {item.nombre}
                    </li>
                  ))}
                </ul>
              </div>
            ) : mostrarSinResultados ? (
              <div className="no-results">
                <p style={{ padding: "10px", color: "#999", fontSize: "14px", textAlign: "center" }}>
                  No encontramos resultados.
                </p>
              </div>
            ): historial.length > 0 ? (
              <div className="recent-searches">
                <ul id="recent-list">
                  {historial.map((item) => (
                    <li key={item.id_busqueda}>
                      <span onClick={() => handleSeleccion(item.termino, item.id_comercio || item.id_sucursal)}>{item.termino}</span>
                      <span className="remove" onClick={() => handleEliminar(item.id_busqueda)}>
                        <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24">
                          <path fill="currentColor" d="m12 13.4l-4.9 4.9q-.275.275-.7.275t-.7-.275t-.275-.7t.275-.7l4.9-4.9l-4.9-4.9q-.275-.275-.275-.7t.275-.7t.7-.275t.7.275l4.9 4.9l4.9-4.9q.275-.275.7-.275t.7.275t.275.7t-.275.7L13.4 12l4.9 4.9q.275.275.275.7t-.275.7t-.7.275t-.7-.275z"/>
                        </svg>
                      </span>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
            <h3 className="suggestion-search-title">¡Quizás podría interesarte!</h3>
            <div className="suggestion-search">
              {sugerencias.map((item) => (
                <div className="suggestion-item" key={item.id_comercio} onClick={() => {
                  const id_perfil = localStorage.getItem("id_perfil");
                  const id_sucursal = item.id_sucursal || item.id; 
                
                  registrarTap(id_sucursal, "podria_interesarte", id_perfil);
                
                  setTimeout(() => {
                    handleSeleccion(item.nombre, id_sucursal);
                  }, 200);
                }}
                >
                  <img src={item.logo} alt={item.nombre} />
                  <div className="suggestion-info">
                    <div className="suggestion-name">
                      {item.nombre}
                      <img src="/assets/images/verified.svg" className="verifiedUser" style={{ width: 300 }} alt="Verificado" />
                    </div>
                    <div className="suggestion-rating">
                      <StarRating filled={Math.round(item.promedio_estrellas || 0)} />
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BottomSheet;
